export default __webpack_public_path__ + "static/media/clock-icon.98b52d3a.svg";